<template>
  <div class="h-full grid grid-rows-[auto_1fr] overflow-hidden">
    <slot name="header">
      <threads-nav :show-center="false" />
    </slot>
    <div class="overflow-hidden h-full">
      <slot />
    </div>
  </div>
</template>
